/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WalletCouponsHalResponse } from '../../models/wallet-coupons-hal-response';

export interface GetCoupons$Params {
  'Active-Tenant-Identifier': string;
  managementCouponId?: string;
}

export function getCoupons(http: HttpClient, rootUrl: string, params: GetCoupons$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletCouponsHalResponse>> {
  const rb = new RequestBuilder(rootUrl, getCoupons.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('managementCouponId', params.managementCouponId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WalletCouponsHalResponse>;
    })
  );
}

getCoupons.PATH = '/wallet/coupons';
